import React, { FC, PropsWithChildren, ReactNode } from "react"
import { useErrorBoundary } from "use-error-boundary"
import { InfoBox } from "@bancacfplus/InfoBox"
import { AxiosError } from "axios"
import { ErrorLike } from "@apollo/client"
import style from "../ErrorBoundaryEnriched/ErrorBoundaryEnriched.module.scss"
import { logErrorPartialPublic, showReportDialog } from "../Sentry/SentryHook"

type ErrorBoundaryPublicProps = PropsWithChildren<{
  error?: Error | AxiosError | ErrorLike
  swallow?: boolean
  message?: ReactNode
  errorContainer?: boolean
  className?: string
}>

export const ErrorBoundaryPublic: FC<ErrorBoundaryPublicProps> = ({
  error,
  swallow = false,
  message = "Ops… qualcosa è andato storto.",
  errorContainer = false,
  children,
  className
}) => {
  const { ErrorBoundary, didCatch } = useErrorBoundary({
    onDidCatch: logErrorPartialPublic
  })

  if (didCatch || error) {
    if (error) {
      logErrorPartialPublic(error.message)
    }

    if (swallow) {
      return <></>
    }

    return (
      <div className={`${errorContainer ? style.errorContainer : ""} ${className ?? ""}`}>
        <InfoBox type="error">
          {message}
          <InfoBox.Action onClick={showReportDialog}>Segnalaci l&apos;errore</InfoBox.Action>
        </InfoBox>
      </div>
    )
  }

  return <ErrorBoundary>{children}</ErrorBoundary>
}
